"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var Query_1 = require("../query/Query");
var replacePlaceholders_1 = require("../utils/replacePlaceholders");
var typeChecks_1 = require("../utils/typeChecks");
function applySubQueryPlaceholders(params) {
    var template = params.template;
    var executionOptions = params.executionOptions, subQueries = params.subQueries, allSubQueryValuesRequired = params.allSubQueryValuesRequired;
    if (subQueries) {
        // If there are subqueries, translate the template before replacing the placeholders
        if (executionOptions && executionOptions.translate) {
            template = executionOptions.translate(template);
        }
        var subQueryValues = {};
        var hasBlankValue = false;
        for (var subQueryIndex = 0; subQueryIndex < subQueries.length; subQueryIndex++) {
            var subQueryOptions = subQueries[subQueryIndex];
            var _a = subQueryOptions.queryId, queryId = _a === void 0 ? "subQuery" + subQueryIndex : _a;
            var subQuery = new Query_1.Query(subQueryOptions, this.translationHelper);
            var subQueryValue = subQuery.execute(executionOptions);
            var key = "sub:" + queryId;
            if (allSubQueryValuesRequired && typeChecks_1.isNullOrEmpty(subQueryValue)) {
                hasBlankValue = true;
                break;
            }
            subQueryValues[key] = subQueryValue;
        }
        if (allSubQueryValuesRequired && hasBlankValue) {
            template = undefined;
        }
        else {
            template = replacePlaceholders_1.replacePlaceholders({ values: subQueryValues, text: template });
        }
    }
    return template;
}
exports.applySubQueryPlaceholders = applySubQueryPlaceholders;
//# sourceMappingURL=applySubQueryPlaceholders.js.map